/*
 * File: dashboard.service.tsx
 * Project: a-a
 * File Created: Friday, 8th November 2024 8:58:09 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 20th December 2024 8:38:22 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

import { ApiConstants } from './api-constants';
export class DashboardService {
  static getDeal = async () => {
    return await (
      await axios.get(ApiConstants.DASHBOARD_API.GET_DEAL.URL())
    ).data;
  };
  static getTasks = async (query: TaskQueryParams) => {
    console.log(ApiConstants.DASHBOARD_API.GET_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(
        ApiConstants.DASHBOARD_API.GET_TASKS.URL() +
          ApiConstants.DASHBOARD_API.GET_TASKS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getActivity = async (query: ActivityQueryParams) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        ApiConstants.DASHBOARD_API.GET_ACTIVITY.URL() +
          ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getClient = async () => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.DASHBOARD_API.GET_CLIENT.URL())
    ).data;
  };
  static getActionAccount = async () => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.DASHBOARD_API.GET_ACTION_ACCOUNT.URL())
    ).data;
  };
  static getSportNews = async (): Promise<{
    latestNews: {
      link: '';
      title: '';
      source: '';
    }[];
  }> => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(ApiConstants.DASHBOARD_API.GET_SPORTS_NEWS.URL())
    ).data;
  };
}
